export const STORE_MONETIZE_TYPE = {
    merchandise: 'merchandise',
    downloadables: 'downloadables',
    nft: 'nft',
    courses: 'courses',
    experiences: 'experiences',
    nfts: 'nfts',
    course: 'course',
    experience: 'experience',
    downloadable: 'downloadable',
    event_ticket: 'event_ticket'
}

export const POST_TYPES = {
    video: 'video',
    article: 'article',
    image: 'image'
}

export const POST_TYPE_ICONS = {
    video: 'icon-fi-sr-play-alt',
    article: 'icon-article-off',
    image: 'icon-fi-sr-picture'
}

export const NEW_STORE_TYPES = {
    newsletter: 'newsletter',
    portfolio: 'portfolio',
    vip_offer: 'vip_offer',
    event_calendar: 'event_calendar'
}

export const STORE_TYPE_ICONS = {
    newsletter: 'icon-litenewsletterIcon',
    portfolio: 'icon-liteportfolio-not-found',
    vip_offer: 'icon-litevalue',
    event_calendar: 'icon-liteic_emprty-event-calender'
}

export const LABELS = {
    UNAVAILABLE_FAILED_TO_LOAD: 'Unavailable or failed to load.'
}